import AppVersion from './AppVersion';

export default AppVersion;
